import { graphql } from 'gatsby';
import { Box } from '@twilio-paste/box';
import { Text } from '@twilio-paste/text';
import { Paragraph } from '@twilio-paste/paragraph';
import Changelog from '@twilio-paste/text/CHANGELOG.md';
import { SidebarCategoryRoutes } from "../../../../src/constants";
import { Callout, CalloutTitle, CalloutText } from "../../../../src/components/callout";
import { DoDont, Do, Dont } from "../../../../src/components/DoDont";
import { InlineCode } from "../../../../src/components/Typography";
import * as React from 'react';
export default {
  graphql,
  Box,
  Text,
  Paragraph,
  Changelog,
  SidebarCategoryRoutes,
  Callout,
  CalloutTitle,
  CalloutText,
  DoDont,
  Do,
  Dont,
  InlineCode,
  React
};